import React from 'react';
import {RouteHandler} from 'react-router';


class CleanTemplate extends React.Component {
    render() {
        return (
            <div className="template-clean">
                <div className="bg-img"></div>
                <main className="page-content">
                    <RouteHandler {...this.props} />
                </main>
            </div>
        )
    }
}


export default CleanTemplate;



/** WEBPACK FOOTER **
 ** ./app/src/views/CleanTemplate.js
 **/